import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* LIBRARIES */
import classNames from 'classnames';
/* STYLES */

import * as stylesModule from '../modalView.css';
/* TYPES */

import { hexToRGB } from '../../utils';

/* TYPES */
var DEFAULT_BACKGROUND_COLOR = 'FFFFFF';
var DEFAULT_Z_INDEX = '10';
export var getSlaveStylesClasses = function getSlaveStylesClasses(_ref) {
  var _classNames;

  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$custom = _ref.custom,
      custom = _ref$custom === void 0 ? {} : _ref$custom;
  var zIndex = styles.zIndex || DEFAULT_Z_INDEX;
  var _custom$mediaType = custom.mediaType,
      mediaType = _custom$mediaType === void 0 ? 'all' : _custom$mediaType;
  return classNames((_classNames = {}, _defineProperty(_classNames, stylesModule["slave-zIndex--".concat(zIndex)], true), _defineProperty(_classNames, stylesModule["slave-hasBackgroundOpacity"], custom.backgroundOpacity), _defineProperty(_classNames, stylesModule["slave-mediaType--".concat(mediaType)], true), _classNames));
};
export var getInlineStyles = function getInlineStyles(_ref2) {
  var _ref2$styles = _ref2.styles,
      styles = _ref2$styles === void 0 ? {} : _ref2$styles,
      _ref2$custom = _ref2.custom,
      custom = _ref2$custom === void 0 ? {} : _ref2$custom;
  var backgroundColor = '';

  if (custom.backgroundOpacity) {
    backgroundColor = hexToRGB(styles.backgroundColor || DEFAULT_BACKGROUND_COLOR, custom.backgroundOpacity);
  }

  return {
    backgroundColor: backgroundColor,
    boxShadow: styles.boxShadow,
    height: styles.height,
    width: styles.width
  };
};